"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.isReceivableRepaymentHistoryData = exports.isCreditFacilityReceivableOriginationSummaryInfo = exports.isBaseRepaymentVintageInputInsightsData = exports.isBaseProfitVintageInputInsightsData = exports.isBaseProfitOverviewInsightsData = exports.isBaseReceivableRiskInsightsData = exports.isBaseBorrowingRiskInsightsData = exports.isBasePrincipalInsightsData = exports.isBaseReceivableExposureInsightsData = exports.isEligibilityAggregateQueryDataType = exports.isCoreBorrowingBaseInsightsData = void 0;
const schema = __importStar(require("../schema"));
const typeguardUtils_1 = require("./typeguardUtils");
exports.isCoreBorrowingBaseInsightsData = (0, typeguardUtils_1.typeguardFunctionLogWrapper)({
    schema: schema.CoreBorrowingBaseInsightsDataSchema,
    typeguardName: 'isCoreBorrowingBaseInsightsData',
});
exports.isEligibilityAggregateQueryDataType = (0, typeguardUtils_1.typeguardFunctionLogWrapper)({
    schema: schema.EligibilityAggregateQueryDataTypeSchema,
    typeguardName: 'isEligibilityAggregateQueryDataType',
});
exports.isBaseReceivableExposureInsightsData = (0, typeguardUtils_1.typeguardFunctionLogWrapper)({
    schema: schema.BaseReceivableExposureInsightsDataSchema,
    typeguardName: 'isBaseReceivableExposureInsightsData',
});
exports.isBasePrincipalInsightsData = (0, typeguardUtils_1.typeguardFunctionLogWrapper)({
    schema: schema.BasePrincipalInsightsDataSchema,
    typeguardName: 'isBasePrincipalInsightsData',
});
exports.isBaseBorrowingRiskInsightsData = (0, typeguardUtils_1.typeguardFunctionLogWrapper)({
    schema: schema.BaseBorrowingRiskInsightsDataSchema,
    typeguardName: 'isBaseBorrowingRiskInsightsData',
});
exports.isBaseReceivableRiskInsightsData = (0, typeguardUtils_1.typeguardFunctionLogWrapper)({
    schema: schema.BaseReceivableRiskInsightsDataSchema,
    typeguardName: 'isBaseReceivableRiskInsightsData',
});
exports.isBaseProfitOverviewInsightsData = (0, typeguardUtils_1.typeguardFunctionLogWrapper)({
    schema: schema.BaseProfitOverviewInsightsDataSchema,
    typeguardName: 'isBaseProfitOverviewInsightsData',
});
exports.isBaseProfitVintageInputInsightsData = (0, typeguardUtils_1.typeguardFunctionLogWrapper)({
    schema: schema.BaseProfitVintageInputInsightsDataSchema,
    typeguardName: 'isBaseProfitVintageInputInsightsData',
});
exports.isBaseRepaymentVintageInputInsightsData = (0, typeguardUtils_1.typeguardFunctionLogWrapper)({
    schema: schema.BaseRepaymentVintageInputInsightsDataSchema,
    typeguardName: 'isBaseRepaymentVintageInputInsightsData',
});
exports.isCreditFacilityReceivableOriginationSummaryInfo = (0, typeguardUtils_1.typeguardFunctionLogWrapper)({
    schema: schema.CreditFacilityReceivableOriginationSummaryInfoSchema,
    typeguardName: 'isCreditFacilityReceivableOriginationSummaryInfo',
});
exports.isReceivableRepaymentHistoryData = (0, typeguardUtils_1.typeguardFunctionLogWrapper)({
    schema: schema.ReceivableRepaymentsHistorySchema,
    typeguardName: 'isReceivableRepaymentHistoryData',
});
//# sourceMappingURL=insights.js.map